<template>
  <div class="sky-page-report-view">
    <div class="el-icon-question wsp-padding-lr-6 wsp-line-height-24">
      1、导入报告后，需要重新刷新; 2、取消勾选再点击确定可取消绑定
    </div>
    <div class="page-function-toolbar">
      <el-button type="primary" @click="handleReturnSelection">确定</el-button>
      <el-button icon="el-icon-refresh" @click="refreshTable"></el-button>
      <el-input
        placeholder="请输入编号/客户/客户岗位/数据包名/联系人模糊筛选"
        class="toolbar-input"
        size="medium"
        v-model="searchKeyword"
        @blur="searchReq"
        @change="searchReq"
      >
        <span slot="suffix" class="el-input__suffix" @click="searchReq"
          ><span class="el-input__suffix-inner"> <i class="el-input__icon el-icon-search"></i></span>
        </span>
      </el-input>

      <el-pagination
        class="toolbar-right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        @prev-click="handelPrev"
        @next-click="handelNext"
        :page-sizes="[5, 10, 20, 50, 100]"
        layout="total,sizes,prev,sp,next"
        :current-page="page"
        :page-size="pageSize"
        :total="pageTotal"
      >
      </el-pagination>
    </div>

    <el-table
      ref="table"
      :border="true"
      :data="specFeatureList"
      :key="reportKey"
      :show-header="true"
      :column-drag-sortable="false"
      class="sky-host-dist"
      @sort-change="handelSortChange"
      @select="selectEvent"
      @select-all="selectAllEvent"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column label="编号" prop="number" width="75"> </el-table-column>
      <el-table-column label="客户" prop="customer" show-overflow-tooltip> </el-table-column>
      <el-table-column label="客户岗位" prop="customerPosition" show-overflow-tooltip> </el-table-column>
      <el-table-column label="数据包名" prop="dataName" show-overflow-tooltip> </el-table-column>
      <el-table-column label="联系人" prop="contactPerson" width="105" show-overflow-tooltip> </el-table-column>
      <el-table-column label="导入时间" prop="createTimeCh" sortable="custom" width="105" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="采集时间" prop="collectTimeCh" sortable="custom" width="105" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" @click="edit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { Table, TableColumn, Button, Drawer, Pagination, Input } from 'element-ui'

import { getCollectList } from '@/api/collect'
import { timestampToTime } from '@/utils/timeUtil'

export default {
  name: 'SkyReportTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Drawer.name]: Drawer,
    [Pagination.name]: Pagination,
    [Input.name]: Input
  },
  props: {
    params: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data: function() {
    return {
      dialogVisible: false,
      searchKeyword: null,
      shwoFunViewDetail: {},
      selectFuntion: [],
      pageTotal: 0,
      pageSize: 20,
      specFeatureList: [],
      selectRowTempList: [],
      tableAllSelectIdList: [],
      noInTablReportList: [],
      reportKey: true,
      page: 1,
      reqParmas: {
        matchArr: [
          {
            type: 'EXACT',
            fieldName: 'projectId',
            valueArr: [this.params.projectId],
            matchRule: 'EQ'
          },
          {
            type: 'EXACT',
            fieldName: 'sceneId',
            valueArr: [this.params.sceneId],
            matchRule: 'EQ'
          }
        ],
        page: this.page - 1,
        limit: 20,
        sortArr: [{ fieldName: 'createTime', direction: 'DESC' }]
      }
    }
  },
  mounted() {
    if (this.params.collectReportDTOList) {
      this.tableAllSelectIdList = this.params.collectReportDTOList
    }
    this.getData()
  },
  methods: {
    refreshTable() {
      this.getData()
    },
    searchReq() {
      if (this.searchKeyword || this.searchKeyword !== '') {
        //
        const exists = this.reqParmas.matchArr.some(obj => obj.fieldNameArr)
        if (exists) {
          for (const iterator of this.reqParmas.matchArr) {
            if (iterator.fieldNameArr) {
              iterator.value = this.searchKeyword
            }
          }
        } else {
          this.reqParmas.matchArr.push({
            type: 'FUZZY',
            fieldNameArr: ['number', 'customer', 'customerPosition', 'dataName', 'contactPerson'],
            value: this.searchKeyword,
            matchRule: 'FULL'
          })
        }
      } else {
        for (let index = 0; index < this.reqParmas.matchArr.length; index++) {
          const element = this.reqParmas.matchArr[index]
          if (element.fieldNameArr) {
            this.reqParmas.matchArr.splice(index, 1)
          }
        }
      }

      this.getData()
    },
    getNotInTableReport() {
      var tableIdList = this.specFeatureList.map(obj => obj.id)
      this.noInTablReportList = []
      this.selectRowTempList = []
      for (const iterator of this.tableAllSelectIdList) {
        if (!tableIdList.includes(iterator.id)) {
          this.noInTablReportList.push(iterator)
        } else {
          this.selectRowTempList.push(iterator)
        }
      }
    },
    refreshSelect() {
      var reportIdArr = []
      if (this.selectRowTempList) {
        reportIdArr = this.selectRowTempList.map(obj => obj.id)
      }
      this.$nextTick(() => {
        this.specFeatureList.forEach(row => {
          //判断 元素是否已经被勾选，那就选中
          if (reportIdArr.includes(row.id)) {
            this.$refs.table.toggleRowSelection(row, true)
          }
        })
      })
    },
    getData() {
      this.reqParmas.page = this.page - 1
      this.reqParmas.limit = this.pageSize
      getCollectList(this.reqParmas).then(res => {
        this.specFeatureList = res.data.content.itemArr
        this.specFeatureList.forEach(element => {
          element.createTimeCh = timestampToTime(element.createTime)
          element.collectTimeCh = timestampToTime(element.collectTime)
        })
        this.reportKey = !this.reportKey
        this.pageTotal = res.data.content.total
        this.getNotInTableReport()
        this.refreshSelect()
      })
    },
    handelSortChange(event, aaa) {
      const exists = this.reqParmas.sortArr.some(obj => obj.fieldName === event.prop)
      if (exists) {
        for (const iterator of this.reqParmas.sortArr) {
          if (iterator.fieldName === event.prop) {
            iterator.direction = 'ascending' === event.order ? 'ASC' : 'DESC'
          }
        }
      } else {
        this.reqParmas.sortArr.push({ fieldName: event.prop, direction: 'ascending' === event.order ? 'ASC' : 'DESC' })
      }
      this.reqParmas.sort = { fieldName: event.prop, direction: 'ascending' === event.order ? 'ASC' : 'DESC' }
      this.getData()
    },
    handleReturnSelection() {
      if (this.selectRowTempList.length + this.noInTablReportList.length > 5) {
        this.$store.dispatch('OpenNotification', { message: '一个场景最多只支持绑定5个报告', type: 'error' })
        return
      }

      var merageArr = this.selectRowTempList.concat(this.noInTablReportList)

      this.$emit('chagneSceneRelation', {
        sceneId: this.params.sceneId,
        sceneName: this.params.sceneName,
        sceneBusiVersion: this.params.sceneBusiVersion,
        bindCollectSoft: this.params.bindCollectSoft,
        collectReportDTOList: merageArr
      })
    },
    selectAllEvent(selection) {
      var reportIdArr = this.specFeatureList.map(obj => obj.id)
      if (selection.length === 0) {
        //移除
        this.selectRowTempList = this.selectRowTempList.filter(obj => !reportIdArr.includes(obj.id))
      } else {
        //增加
        var tempReportIdArr = this.selectRowTempList.map(obj => obj.id)
        selection.forEach(row => {
          if (!tempReportIdArr.includes(row.id)) {
            this.selectRowTempList.push(row)
          }
        })
      }
    },
    selectEvent(select, row) {
      var selectedIdArr = select.map(obj => obj.id)
      if (selectedIdArr.includes(row.id)) {
        //选中
        if (this.selectRowTempList) {
          var reportIdArr = this.selectRowTempList.map(obj => obj.id)
          if (!reportIdArr.includes(row.id)) {
            this.selectRowTempList.push(row)
          }
        } else {
          this.selectRowTempList = []
          this.selectRowTempList.push(row)
        }
      } else {
        //移除
        this.selectRowTempList = this.selectRowTempList.filter(obj => obj.id !== row.id)
      }
    },
    handleCloseDrawer() {
      this.shwoFunViewDetail = {}
      this.dialogVisible = false
    },
    // size 变更 每页条数
    handleSizeChange(val) {
      this.page = 1
      this.pageSize = val
      this.getData()
    },
    //
    handleCurrentChange() {},
    handelPrev() {
      this.page--
      this.getData()
    },
    handelNext() {
      this.page++
      this.getData()
    },
    edit(row) {
      this.$store.dispatch('OpenNotification', {
        message: '为保证数据一致性，编辑客户环境采集报告将会清空环境信息确认和测试用例清单步骤相关数据',
        type: 'warning'
      })
      this.$emit('edit', row.id)
      this.$parent.$parent.$parent.showBtns({
        preStep: true,
        nextStep: true,
        saveStep: false,
        enableTabChange: true
      })
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(page-report-view) {
  height: 100%;
  padding: 0 12px;
  .page-function-toolbar {
    .toolbar-input {
      width: 39%;
    }
    .toolbar-left {
      float: left;
    }
    .toolbar-right {
      float: right;
    }
  }
}
</style>
